import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import { Button, Tab, Tabs } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addTimelineAction, deleteAcccountReducerAction, deleteDataUsingFormData, ExportDownloadReducerAction, ExportXLSXDownloadReducerAction, ExportZipDownloadReducerAction, FetchSingleRecordAction, getMOPInstructionAction, popUpUpdate } from "../../../../store/actions/createTicketManageFields";
import {addSiteTimelineData } from "../../../../common/config";

const SiteTimelineCommentEdit = ({setcommonModalState, editSiteTimelineComment,setEditSiteTimelineComment,Header,modalSize="xl",activityTimeId,activityTimeline,type}) => {


    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        watch,
        reset,
        formState: { errors },
      } = useForm({});

      const onSubmit = async (data) => {


        setValue("comment","")
        dispatch(addTimelineAction(addSiteTimelineData + "/"+activityTimeId+`?type=${type}`,data));
       
        setEditSiteTimelineComment(false)
      };

      
           
     

  return (
    <>
     {/* Add Time for Site time line modal starts here */}
     <Modal
        size={modalSize ? modalSize : "xl"}
        show={editSiteTimelineComment}
        onHide={() => setEditSiteTimelineComment(false)}
        aria-labelledby="example-modal-sizes-title-xl"
        backdrop="static"
      >
        <Modal.Header className="CommonModalHeader">
          <Modal.Title id="example-modal-sizes-title-xl ">
            <h4 className="CommonModalHeaderHeading">{Header}</h4>
            <Button
              variant=""
              className="close CommonModalClose"
              onClick={() => {
                setEditSiteTimelineComment(false)
            
              }}
            >
              <span className="CommonModalClose">&times;</span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white", padding: "0px !important" }}>
        <div>
       <form onSubmit={handleSubmit(onSubmit)}> 
        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            Comment 
                            </label>
                          <input
                          type="textbox"
                            className="form-control"
                            style={{ height: "32px" }}
                            placeholder="Comment Here"
                            {...register("comment", {
                              // required: "Please Enter a Comment",
                              // pattern: {
                              //   // value: /^\d{8}$/,
                              //   message: "Please Enter a Comment"
                              // }
                            })}
                          />

                          {/* {errors.comment && (
                            <p className="error">
                              {errors.comment.message}
                            </p>
                          )} */}
                        </div>

        <div className="py-3 d-flex justify-content-center align-items-center">
          <button type="submit" className="btn btn-primary btn-xs ">
            Submit
          </button>

        </div>
      </form>
    </div>
        </Modal.Body>
      </Modal>


    {/* Add Time for Site time line modal e ds here */}

    </>
  )
}

export default SiteTimelineCommentEdit